module.exports = __webpack_public_path__ + "img/kejifuwu.ec121792.png";